<footer class="main-footer">
    <div class="float-right d-none d-sm-block">
        <b>Version</b> 1.0.0 2021-11-01
    </div>
    <strong>
        Copyright &copy; 2021 <a href="http://e-vtc.com">http://e-vtc.com</a>.</strong> All rights reserved.
</footer>